export default "/images/nstep3phone.png?b3e26c19eda6d41cfe422133245faf34";